import React, { useEffect, useState } from 'react';
import Modal from '../Modal';
import ThirdStep from './ClaimSteps/ThirdStep';
import FirstStep from './ClaimSteps/FirstStep';
import MdArrowBack from '@meronex/icons/ios/MdArrowBack';
import GrClose from '@meronex/icons/gr/GrClose';
import SecondStep from './ClaimSteps/SecondStep';
import FourthStep from './ClaimSteps/FourthStep';
import FifthStep from './ClaimSteps/FifthStep';
import MiniSurvey from './MiniSurvey';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import BsArrowLeft from '@meronex/icons/bs/BsArrowLeft';
import { isRewardsVisible } from '../../../utils/routing';
import SixthStep from './ClaimSteps/SixthStep';
import SeventhStep from './ClaimSteps/SeventhStep';
import EightStep from './ClaimSteps/EightStep';

function KYCModal({
    visible,
    onClick,
    userAccountSummary,
    getUserAccountSummary,
    closeKYCModal,
    step,
    error,
    showError,
    setStep,
    rewardTypeSelected,
    claimInProgress,
    initiateWorkflow,
    isKycCompleted,
    isUpdateWorkflow,
    checkBankVerificationStatus,
    loading,
    checkKycVerificationStatus,
    setOpenKYCModal,
    cashOutFlow,
    setClaimInProgress,
    fromRewardForm,
    bankstatus,
    isKycFailed,
    isBankVerificationFailed,
    isKycProcessing
}) {
    const [show, setShow] = useState(isRewardsVisible ? true : false);
    const [showMessage, setShowMessage] = useState(false);
    const history = useHistory();

    // console.log("isKYCPRocessing inside KYC Modal", isKycProcessing);
   
    useEffect(() => {
        history.replace({
            pathname: history.location.pathname
        });
    }, [history]);

    const totalPoints = Number(
        userAccountSummary?.unInvoicedCommission +
            userAccountSummary?.rewardPoints
    );
    // console.log("Cashout Flow", cashOutFlow);
    // console.log("Total Points inside KYC MODAL" , totalPoints);

    const conditionalComponent = () => {
        if (
            (

                (isNaN(parseInt(userAccountSummary?.unInvoicedCommission)) ||
                    !parseInt(userAccountSummary?.unInvoicedCommission)) && cashOutFlow
            ) || (
                  totalPoints === 0 &&
                  !cashOutFlow
            )
        ) {
            return (
                <ThirdStep
                    loading={loading}
                    nothingToClaim
                    closeUploadBox={closeKYCModal}
                />
            );
        }
        switch (step) {
            case 0:
                return (
                    <>
                        <div className="flex justify-end mr-4 mt-3">
                            <GrClose
                                onClick={closeKYCModal}
                                className={`h-4 w-4 cursor-pointer`}
                            />
                        </div>

                        <FirstStep
                            closeKYCModal={closeKYCModal}
                            setStep={setStep}
                            loading={loading}
                            checkKycVerificationStatus={
                                checkKycVerificationStatus
                            }
                            error={error}
                            setOpenUploadBox={setOpenKYCModal}
                            initiateWorkflow={initiateWorkflow}
                        />
                    </>
                );
            case 1:
                return (
                    <>
                        <div
                            className={`flex ${isUpdateWorkflow
                                    ? 'justify-between'
                                    : 'justify-end'
                                } `}
                        >
                            {isUpdateWorkflow && (
                                <div
                                    className="flex items-center ml-3 cursor-pointer"
                                    onClick={() => setStep(3)}
                                >
                                    {' '}
                                    <MdArrowBack />{' '}
                                    <button className="ml-1">Go Back</button>
                                </div>
                            )}
                            <GrClose
                                onClick={closeKYCModal}
                                className={`md:self-center h-4 w-4 cursor-pointer mr-3 `}
                            />
                        </div>
                        <SecondStep
                            loading={loading}
                            isUpdateWorkflow={isUpdateWorkflow}
                            initiateWorkflow={initiateWorkflow}
                            closeUploadBox={closeKYCModal}
                            isKycCompleted={isKycCompleted}
                            setStep={setStep}
                            cashOutFlow={cashOutFlow}
                            isKycFailed={isKycFailed}
                            isBankVerificationFailed={isBankVerificationFailed}
                            isKycProcessing={isKycProcessing}
                        />
                    </>
                );
            case 2:
                return (
                    <>
                        <div className="flex justify-end">
                            <GrClose
                                onClick={closeKYCModal}
                                className={`md:self-center h-4 w-4 cursor-pointer mr-3 `}
                            />
                        </div>
                        <ThirdStep
                            loading={loading}
                            claimInProgress={claimInProgress}
                            setClaimInProgress={setClaimInProgress}
                            fromRewardForm={fromRewardForm}
                            closeUploadBox={closeKYCModal}
                            isKycProcessing={isKycProcessing}
                        />
                    </>
                );
            case 3:
                return (
                    <>
                        <div className="flex justify-end pr-3 md:pr-4 pt-3">
                            {show && (
                                <GrClose
                                    onClick={closeKYCModal}
                                    className={`md:self-center h-4 w-4 cursor-pointer mr-3 `}
                                />
                            )}
                        </div>
                        <MiniSurvey
                            show={show}
                            setShow={setShow}
                            closeKYCModal={closeKYCModal}
                            showMessage={showMessage}
                            setShowMessage={setShowMessage}
                            bankstatus={bankstatus}
                        />
                        {!show && (
                            <>
                                {!rewardTypeSelected && (
                                    <div className="flex justify-between pl-3 md:pl-8 pr-2 pt-4">
                                        <h2 className=" font-Poppins font-bold text-lg ">
                                            Confirm your details
                                        </h2>
                                        {!show && (
                                            <GrClose
                                                onClick={closeKYCModal}
                                                className={`md:self-center h-4 w-4 cursor-pointer mr-3 `}
                                            />
                                        )}
                                    </div>
                                )}
                                <FourthStep
                                    setClaimInProgress={setClaimInProgress}
                                    checkKycVerificationStatus={
                                        checkKycVerificationStatus
                                    }
                                    claimInProgress={claimInProgress}
                                    checkBankVerificationStatus={
                                        checkBankVerificationStatus
                                    }
                                    getUserAccountSummary={
                                        getUserAccountSummary
                                    }
                                    setStep={setStep}
                                    rewardTypeSelected={rewardTypeSelected}
                                    closeKYCModal={closeKYCModal}
                                />
                            </>
                        )}
                    </>
                );
            case 4:
                return (
                    <>
                        <div className="flex justify-between pl-3 md:pl-8 pr-3 pt-4">
                            <BsArrowLeft
                                className="text-black w-6 h-full cursor-pointer"
                                onClick={() => setStep(0)}
                            />

                            <GrClose
                                onClick={closeKYCModal}
                                className={`md:self-center h-4 w-4 cursor-pointer mr-2`}
                            />
                        </div>

                        <FifthStep
                            userAccountSummary={userAccountSummary}
                            getUserAccountSummary={getUserAccountSummary}
                            setStep={setStep}
                            setOpenKYCModal={setOpenKYCModal}
                            closeKYCModal={closeKYCModal}
                            initiateWorkflow={initiateWorkflow}
                            bankstatus={bankstatus}
                        />
                    </>
                );
            case 5:
                return (
                    <>
                        <div className="flex justify-end">
                            <GrClose
                                onClick={closeKYCModal}
                                className={`md:self-center h-4 w-4 cursor-pointer mr-3 `}
                            />
                        </div>
                        <SixthStep setStep={setStep} />
                    </>
                );
            case 6:
                return (
                    <>
                       
                        <SeventhStep
                            setStep={setStep}
                            isKycFailed={isKycFailed}
                            isBankVerificationFailed={isBankVerificationFailed}
                        />
                    </>
                );
            case 7:
                return (
                    <>
                        <div className="flex justify-end">
                            <GrClose
                                onClick={closeKYCModal}
                                className={`md:self-center h-4 w-4 cursor-pointer mr-3 `}
                            />
                        </div>
                        <EightStep setStep={setStep}
                            closeKYCModal={closeKYCModal} />
                    </>
                );
        }
    };

    return (
        <Modal visible={visible} onClick={onClick}>
            <div
                className={`${step === 0 || step === 3
                        ? `overflow-y-scroll scrollbar-thin ${step === 0 ? 'h-[80vh] ' : 'h-[90vh]'
                        }`
                        : ''
                    } ${step === 3 && show && showMessage
                        ? 'md:h-auto'
                        : (step === 3 && show && !showMessage) || step === 0
                            ? 'md:h-[80vh]'
                            : 'md:h-auto'
                    }`}
            //  ${step === 3 && show  ? 'md:h-[90vh]' : ''}`}
            >
                {conditionalComponent(step)}
            </div>

            {showError && (
                <div class="alert alert-error w-[80%] animate-pulse mx-auto h-auto mb-2 ">
                    <label>{error}</label>
                </div>
            )}
        </Modal>
    );
}

export default KYCModal;
